import {IGeoLocationParams} from "./geo_service_interface";
import GeoBase, {IGeoParams} from "./geo_base";
import {GEO_LOCATION} from "./geo_consts";
import GeoHybrid from "./geo_hybrid";
import GeoPc from "./geo_pc";
import Device from "../../utils/device/device";
import {IGeoLocationWrapperFactory} from "./geo_location_wrapper_factory_interface";

export class GeoLocationWrapperFactory implements IGeoLocationWrapperFactory{
    public getGeoWrapper(params:IGeoLocationParams): GeoBase {
        let wrapper = null;
        let type:string = this._getDeviceType();
        let wrapperParams:IGeoParams;
        switch (type) {
            case GEO_LOCATION.GEO_HYBRID_ANDROID:
                wrapperParams = params.Hybrid.android;
                wrapper = GeoHybrid.create(wrapperParams);
                break;

            case GEO_LOCATION.GEO_HYBRID_IOS:
                wrapperParams = params.Hybrid.ios;
                wrapper = GeoHybrid.create(wrapperParams);
                break;

            case GEO_LOCATION.GEO_PC:
                wrapperParams = params.PC;
                wrapperParams.platform = GEO_LOCATION.WIN;
                wrapper = GeoPc.create(wrapperParams);
                break;

            case GEO_LOCATION.GEO_MAC:
                wrapperParams = params.PC;
                wrapperParams.platform = GEO_LOCATION.MAC;
                wrapper = GeoPc.create(wrapperParams);
                break;

            case GEO_LOCATION.GEO_WEBAPP_IOS:
            case GEO_LOCATION.GEO_WEBAPP_ANDROID:
                break;
        }
        return wrapper;
    }

    private _getDeviceType():string{
        let type = "";
        if (Device.hybrid.inCasino){
            if (Device.os.isIOS){
                type = GEO_LOCATION.GEO_HYBRID_IOS
            } else {
                type = GEO_LOCATION.GEO_HYBRID_ANDROID
            }
        } else if (Device.os.isIOS || Device.isProbablyIOSDevice){
            type = GEO_LOCATION.GEO_WEBAPP_IOS
        } else if (Device.os.isAndroid){
            type = GEO_LOCATION.GEO_WEBAPP_ANDROID
        }
        else {
            if (Device.os.isMacOS){
                type = GEO_LOCATION.GEO_MAC
            } else {
                type = GEO_LOCATION.GEO_PC
            }
        }
        return type
    }
}